import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';

const initialState = {
  notifications: {}, 
  loading: false,
  error: null,
  pagination: {},
  selectedNotification:null
};

/* ================== THUNKS ================== */

export const fetchEmailNotifications = createAsyncThunk(
  'email-notifications/fetch',
  async ({ fetchType = "table", page = 1, limit = 10, search = '' }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get('/api/admin/email-notifications', {
          params: { fetchType, page, limit, search }
        });
        return {
            data: response.data?.data?.records || [],
            pagination: response.data?.data?.pagination || {},
        };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const createEmailNotification = createAsyncThunk(
  'email-notifications/create',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        '/api/admin/email-notifications', 
        payload
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data);
    }
  }
);

export const fetchEmailNotificationById = createAsyncThunk(
  'email-notifications/fetchById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/api/admin/email-notifications/${id}`);
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const updateEmailNotification = createAsyncThunk(
  'email-notifications/update',
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`/api/admin/email-notifications/${id}`, formData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data);
    }
  }
);

export const deleteEmailNotification = createAsyncThunk(
  'email-notifications/delete',
  async ({ id }, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`/api/admin/email-notifications/${id}`);
      return { id };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const sendEmailNotification = createAsyncThunk(
  'email-notifications/send',
  async ({id}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`/api/admin/email-notifications/send/${id}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);




/* ================== SLICE ================== */

const emailNotificationSlice = createSlice({
  name: 'email-notifications',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
        /* FETCH */
        .addCase(fetchEmailNotifications.pending, (state) => {
            state.loading = true;
        })
        .addCase(fetchEmailNotifications.fulfilled, (state, action) => {
            const { data, pagination } = action.payload;
            state.loading = false;
            state.pagination = pagination;
            state.notifications = data;
        })
        .addCase(fetchEmailNotifications.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(fetchEmailNotificationById.fulfilled, (state, action) => {
            state.loading = false;
            state.selectedNotification = action.payload;
        })
        .addCase(fetchEmailNotificationById.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        /* UPDATE */
        .addCase(updateEmailNotification.fulfilled, (state, action) => {        
            console.log(state,'state');
        })
        .addCase(updateEmailNotification.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(sendEmailNotification.fulfilled, (state, action) => {
            state.loading = false;
            
        })       
        /* DELETE */
        .addCase(deleteEmailNotification.fulfilled, (state, action) => {
          state.notifications = state.notifications.filter((p) => p._id !== action.payload);
        });
  }
});

export default emailNotificationSlice.reducer;